import { platform } from './platform';

export const environment = {
    admin: true,
    production: true,
    env: 'dev',
    baseDomain: 'dev.vizorro.ru',
    urls: {
        app: 'https://app.dev.vizorro.ru',
        auth: 'https://auth.dev.vizorro.ru',
        api: 'https://api.dev.vizorro.ru',
        rmq: 'wss://rmq.dev.vizorro.ru',
    },
    firebaseConfig: {
        apiKey: "AIzaSyCux7nsSzVH_4JCdGBCTx42Yq1rmbXOqAU",
        authDomain: "vizoro.firebaseapp.com",
        projectId: "vizoro",
        storageBucket: "vizoro.appspot.com",
        messagingSenderId: "578585105276",
        appId: "1:578585105276:web:d9d4fc7c6bc195089f4af9",
        measurementId: "G-NVC1704CZ8"
    },
    useAuthCookie: false,
    platform
};

export function sendBugReport(error: any): void {
    const cmpName = error?.ngDebugContext?.component?.__TAG
        ? error.ngDebugContext.component.__TAG
        : (error?.ngDebugContext?.component?.constructor?.name ? error.ngDebugContext.component.constructor.name : '<UnknownComponent>');
}
